// 여러 작업(jobId)의 퍼센트를 받아 평균 집계해서 하단 바에 반영
let listeners = new Set();
const jobs = new Map(); // jobId -> percent(0~100)

const state = {
    visible: false,
    percent: 0,
    hideTimer: null,
};

function notify() {
    const snap = { visible: state.visible, percent: state.percent };
    listeners.forEach(fn => fn(snap));
}

function recompute() {
    if (jobs.size === 0) {
        state.percent = 100;
        notify();
        clearTimeout(state.hideTimer);
        state.hideTimer = setTimeout(() => {
            state.visible = false;
            state.percent = 0;
            notify();
        }, 250);
        return;
    }

    let sum = 0;
    jobs.forEach(p => (sum += Math.min(100, Math.max(0, p))));
    state.percent = Math.round(sum / jobs.size);
    state.visible = true;
    notify();
}

function begin(jobId, startAt = 0) {
    jobs.set(jobId, startAt);
    recompute();
}
function set(jobId, percent) {
    if (!jobs.has(jobId)) jobs.set(jobId, 0);
    jobs.set(jobId, percent);
    recompute();
}
function end(jobId) {
    jobs.delete(jobId);
    recompute();
}

function subscribe(fn) {
    listeners.add(fn);
    // 초기 상태 전달
    fn({ visible: state.visible, percent: state.percent });
    return () => listeners.delete(fn);
}

export const RealLoadingBar = { begin, set, end, subscribe };
